// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import ArrowLeft from "@insite/mobius/Icons/ArrowLeft";
import { productCompareCarouselStyles } from "@sc/Overrides/Widgets/ProductCompare/ProductCompareCarousel";
import Close from "@sc/XDL/Icons/Close";
import { color, createLinkIconStyles } from "@sc/XDL/Utilities";
import { css } from "styled-components";

productCompareCarouselStyles.removeLink = {
    ...createLinkIconStyles(Close, {
        css: css`
            position: absolute;
            top: 4px;
            right: 4px;
            &&:hover > ${IconWrapper}, &:focus > ${IconWrapper} {
                color: ${color("common.ui8")};
            }
        `,
        icon: {
            iconProps: {
                size: 9,
                css: css`
                    margin: 0;
                `,
            },
        },
    }),
};

productCompareCarouselStyles.headerGridItem = {
    width: 12,
};
productCompareCarouselStyles.headerButtonsGridItem = {
    width: 12,
    css: css`
        display: flex;
        justify-content: space-between;
    `,
};
productCompareCarouselStyles.subtitle = {
    weight: "bold",
};
productCompareCarouselStyles.navigationLink = {
    ...createLinkIconStyles(ArrowLeft, {
        css: css`
            margin-top: 12px;
        `,
    }),
};
productCompareCarouselStyles.container = {
    gap: 16,
};
productCompareCarouselStyles.headerText = {
    variant: "h1",
    css: css`
        margin-bottom: 0;
    `,
};
productCompareCarouselStyles.headerContainer = {
    gap: 16,
};
productCompareCarouselStyles.carouselProductStyles = {
    productGridContainer: {
        container: {
            css: css`
                max-width: 321px;
            `,
        },
    },
};
